import type { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router'

export function useMetaTitle(route: RouteRecordRaw | RouteLocationNormalizedLoaded) {
  const { title } = route.meta ?? {}
  //useTitle(title)
  document.title = title ? `${title} - Quản lý dự án - DNP Water` : 'Quản lý dự án - DNP Water'
}
